import React, { useState, useEffect, useContext, Fragment } from "react";
import { Button } from "react-bootstrap";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import ListFilters from "components/sales/ListFilters/ListFilters";
import { toast } from "react-toastify";

const AbscondDriverList = ({
    getAllAbscondedDrivers,
    releaseAbscondedDrivers,
    approveAbscondedDrivers,
    allAbscondDriverList = [],
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [roleId, setRoleId] = useState("");
  
  const localData = localStorage.getItem('applyFilter');
    let current_status = 'PENDING';
    
    const abscondingStatus = ['PENDING','PROCESSED','REJECTED']; 

    const current_filter = JSON.parse(localData || '{}');
    if (current_filter?.status && abscondingStatus.includes(current_filter.status)) {
        current_status = current_filter.status;
    }

  const pendingHeaders = [
    "Driver Name",
    "Phone No.",
    "Abscond By",
    "Abscond Request Date",
    "Abscond Reason",
    "Status",
    "Created At",
    "Update Status",
  ];

  const Headers = [
    "Driver Name",
    "Phone No.",
    "Abscond By",
    "Abscond Request Date",
    "Abscond Reason",
    "Status",
    "Created At"
  ];

  useEffect(() => {
    const fetchData = async () => {
        setIsLoading(true);
        await getAllAbscondedDrivers(1,true,current_status);
        setIsLoading(false);
    };
    fetchData();
  }, [roleId]);
  
  useEffect(() => {
    const tableData = [
      "id",
      "user_name",
      "phone_number",
      "absconded_by",
      "abscond_request_date",
      "abscond_reason",
      "status",
      "created_at"
    ];

    setListData();
    if (allAbscondDriverList && allAbscondDriverList?.resultSets) {
      const data = allAbscondDriverList?.resultSets?.map((element) =>
        Object.assign(
          
          ...tableData.map((key) => ({
            [key]:
                key === "absconded_by"
                ? element.salary_components?.[0]?.requested_by_role || ""
                : key === "abscond_request_date"
                    ? element.salary_components?.[0]?.created_at || ""
                    : key === "abscond_reason"
                    ? element.salary_components?.[0]?.details?.remark || ""
                    : element[key],
                })),
                current_status === "PENDING"
                ? {
                    Custom: [
                    {
                        name: localization.abscondPermanently,
                        id: element.id,
                    },
                    {
                        name: localization.releaseSalary,
                        id: element.id,
                        salary_id: element.salary_components?.[0]?.id,
                    },
                    ],
                }
                : 
                {}
        )
      );
      data && setListData(data);
      setPageCount(
        Math.ceil(
            allAbscondDriverList?.total/
            allAbscondDriverList?.to
        )
      );
    }
  }, [allAbscondDriverList]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getAllAbscondedDrivers(1,true, filterData?.status);
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  const actionButtons = () => (
    <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger filter-btn btn btn-transparent"
        >
          {localization.releaseSalary}
        </Button>
        <Button
          onClick={filterToggle}
          className="filter-hamburger filter-btn btn btn-transparent"
        >
          {localization.abscondPermanently}
        </Button>
    </Fragment>
  );
  
  const handleStatusChange = async (id, type, salary_id=null) => {
        if(type == localization.abscondPermanently){
            const data = {
                status: "OPS_ABSCONDED",
                monthly_salary_record_id : [id],
            }
            setIsLoading(true);
            const res = await approveAbscondedDrivers(data);
            if(res.data.status && res.data.status_code == 200){
                toast.success("Absconded Successfully")
            }
            setIsLoading(false);
            setTimeout(()=>{
                window.location.reload();
            }, 2000) 
        }
        else if(type == localization.releaseSalary){
            const data = {
                action: "update",
                salary_component_id: salary_id,
                status: "REJECTED"
            }
            setIsLoading(true);
            const res = await releaseAbscondedDrivers(data);
            if(res.data.status && res.data.status_code == 200){
                toast.success("Salary Released Successfully")
            }
            setIsLoading(false);
            setTimeout(()=>{
                window.location.reload();
            }, 2000) 
        }
 }

  const onPageChange = async (val) => {
    setIsLoading(true);
    if(filterData && filterData.status){
      await getAllAbscondedDrivers(val.selected + 1,true, filterData?.status);
    }
    else{
        await getAllAbscondedDrivers(val.selected + 1,true, "PENDING");
    }
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.abscondDriverList}
      Buttons={headerBtns}
      className={false ? "requiredFileds" : ""}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        headers={current_status === "PENDING" ? pendingHeaders : Headers}
        pageCount={pageCount}
        handleStatusChange={handleStatusChange}
        onPageChange={onPageChange}
        isId={false}
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        AbscondDriverFilter={true}
      />
    </Layout>
  );
};

export default AbscondDriverList;
